export const PET_SHEET_GRID_DONE_MESSAGE = "mind-survival-pet-sheet-grid-done";
export const PET_SHEET_GRID_CREATED_MESSAGE = "mind-survival-pet-sheet-grid-created";

export const PET_SHEET_GRID_RESULT_STORAGE_KEY =
  "mind-survival/pet-sheet-grid-result/v1";

export const PET_SHEET_GRID_CREATE_SESSION_KEY =
  "mind-survival/pet-sheet-grid-create-session/v1";

export type PetSheetGridCreateSession = {
  draftName: string;
  startedAt: number;
};

export type PetSheetGridResult = {
  dataUrl: string;
  createdAt: number;
};

export function savePetSheetGridResult(dataUrl: string): void {
  const payload: PetSheetGridResult = {
    dataUrl,
    createdAt: Date.now(),
  };
  sessionStorage.setItem(PET_SHEET_GRID_RESULT_STORAGE_KEY, JSON.stringify(payload));
}

export function takePetSheetGridResult(): PetSheetGridResult | null {
  const raw = sessionStorage.getItem(PET_SHEET_GRID_RESULT_STORAGE_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(PET_SHEET_GRID_RESULT_STORAGE_KEY);
  try {
    const parsed = JSON.parse(raw) as Partial<PetSheetGridResult>;
    if (typeof parsed.dataUrl !== "string" || !parsed.dataUrl.startsWith("data:")) {
      return null;
    }
    return {
      dataUrl: parsed.dataUrl,
      createdAt: typeof parsed.createdAt === "number" ? parsed.createdAt : Date.now(),
    };
  } catch {
    return null;
  }
}

export function notifyPetSheetGridOpener(): void {
  try {
    window.opener?.postMessage(
      { type: PET_SHEET_GRID_DONE_MESSAGE },
      window.location.origin,
    );
  } catch {
    /* cross-origin or closed */
  }
}

export function savePetSheetGridCreateSession(draftName: string): void {
  const payload: PetSheetGridCreateSession = {
    draftName: draftName.trim().slice(0, 48),
    startedAt: Date.now(),
  };
  sessionStorage.setItem(PET_SHEET_GRID_CREATE_SESSION_KEY, JSON.stringify(payload));
}

export function readPetSheetGridCreateSession(): PetSheetGridCreateSession | null {
  const raw = sessionStorage.getItem(PET_SHEET_GRID_CREATE_SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<PetSheetGridCreateSession>;
    if (typeof parsed.startedAt !== "number") return null;
    return {
      draftName: typeof parsed.draftName === "string" ? parsed.draftName : "",
      startedAt: parsed.startedAt,
    };
  } catch {
    return null;
  }
}

export function clearPetSheetGridCreateSession(): void {
  sessionStorage.removeItem(PET_SHEET_GRID_CREATE_SESSION_KEY);
}

export function notifyPetSheetGridCreated(petName: string): void {
  try {
    window.opener?.postMessage(
      { type: PET_SHEET_GRID_CREATED_MESSAGE, name: petName },
      window.location.origin,
    );
  } catch {
    /* cross-origin or closed */
  }
}
